"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var swr_1 = require("swr");
var swr_firestore_1 = require("@nandorojo/swr-firestore");
var error_boundary_1 = __importDefault(require("./error-boundary"));
var loader_1 = __importDefault(require("./loader"));
var firebase_1 = require("../lib/firebase");
var auth_1 = __importDefault(require("../context/auth"));
var SharedProvider = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_1.default.StrictMode, null,
        react_1.default.createElement(swr_1.SWRConfig, { value: { suspense: true } },
            react_1.default.createElement(error_boundary_1.default, null,
                react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement(loader_1.default, { background: "white" }) },
                    react_1.default.createElement(swr_firestore_1.FuegoProvider, { fuego: firebase_1.fuego },
                        react_1.default.createElement(auth_1.default.Provider, null, children)))))));
};
exports.default = SharedProvider;
//# sourceMappingURL=provider.js.map